module.exports = __webpack_public_path__ + "images/emoji/broken_heart.9a129a3b5d2ed1a62d13.png";